import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'euiTableHighlightFilter',
})
export class EuiTableHighlightFilterPipe implements PipeTransform {

    transform(value: string, strFilter: string, className = 'eui-table--highlighted'): string {
        if (strFilter && strFilter.length > 0) {
            const regex = new RegExp('(' + strFilter + ')', 'gi');
            return value.toString().replace(regex, '<span class="' + className + '">$1</span>');
        } else {
            return value;
        }
    }

}
